var _path, _rect, _rect2, _rect3, _rect4, _path2, _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgName(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 428.36 428.36",
    style: {
      enableBackground: "new 0 0 428.36 428.36"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_17_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#60A57C"
    },
    d: "M220.9,54.965v43.06c0,3.71-3.02,6.72-6.72,6.72c-3.71,0-6.73-3.01-6.73-6.72v-43.06H220.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6BCE95"
    },
    d: "M240.13,65.385v79.98h-51.92v-79.98c0-5.68,4.58-10.31,10.24-10.41v43.05 c0,8.67,7.06,15.72,15.73,15.72c8.67,0,15.72-7.05,15.72-15.72v-43.05C235.56,55.075,240.13,59.705,240.13,65.385z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F97946"
    },
    d: "M172.01,345.565H46.58c1.47-28.14,21.91-52.33,49.69-58.19l0.51-8.66 c-15.8-5.36-26.42-20.18-26.42-36.87c0-21.47,17.46-38.94,38.93-38.94s38.93,17.47,38.93,38.94c0,16.69-10.62,31.51-26.42,36.87 l0.52,8.66C150.1,293.235,170.53,317.425,172.01,345.565z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#4489D3"
    },
    d: "M182.13,169.755v175.81h-1.11c-1.3-28.4-19.5-53.35-45.5-63.59c13.32-8.7,21.7-23.68,21.7-40.13 c0-26.43-21.5-47.94-47.93-47.94s-47.93,21.51-47.93,47.94c0,16.45,8.38,31.43,21.71,40.13c-26,10.24-44.2,35.19-45.5,63.59 h-1.12v-175.81H182.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFCC73"
    },
    d: "M419.36,141.915v231.48H9v-231.48h170.21v12.45h69.92v-12.45H419.36z M396.39,340.555v-9H237.55v9 H396.39z M396.39,293.815v-9H237.55v9H396.39z M396.39,247.065v-9H237.55v9H396.39z M396.39,200.325v-9H237.55v9H396.39z  M191.13,354.565v-193.81H27.45v193.81H191.13z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M428.36,132.915v249.48H0v-249.48h179.21v-67.53c0-10.71,8.72-19.42,19.43-19.42h31.07c10.71,0,19.42,8.71,19.42,19.42 v67.53H428.36z M419.36,373.395v-231.48H249.13v12.45h-69.92v-12.45H9v231.48H419.36z M240.13,145.365v-79.98 c0-5.68-4.57-10.31-10.23-10.41v43.05c0,8.67-7.05,15.72-15.72,15.72c-8.67,0-15.73-7.05-15.73-15.72v-43.05 c-5.66,0.1-10.24,4.73-10.24,10.41v79.98H240.13z M220.9,98.025v-43.06h-13.45v43.06c0,3.71,3.02,6.72,6.73,6.72 C217.88,104.745,220.9,101.735,220.9,98.025z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 237.55,
    y: 331.555,
    width: 158.84,
    height: 9
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 237.55,
    y: 284.815,
    width: 158.84,
    height: 9
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 237.55,
    y: 238.065,
    width: 158.84,
    height: 9
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 237.55,
    y: 191.325,
    width: 158.84,
    height: 9
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.13,160.755v193.81H27.45v-193.81H191.13z M182.13,345.565v-175.81H36.45v175.81h1.12 c1.3-28.4,19.5-53.35,45.5-63.59c-13.33-8.7-21.71-23.68-21.71-40.13c0-26.43,21.5-47.94,47.93-47.94s47.93,21.51,47.93,47.94 c0,16.45-8.38,31.43-21.7,40.13c26,10.24,44.2,35.19,45.5,63.59H182.13z M46.58,345.565h125.43 c-1.48-28.14-21.91-52.33-49.69-58.19l-0.52-8.66c15.8-5.36,26.42-20.18,26.42-36.87c0-21.47-17.46-38.94-38.93-38.94 s-38.93,17.47-38.93,38.94c0,16.69,10.62,31.51,26.42,36.87l-0.51,8.66C68.49,293.235,48.05,317.425,46.58,345.565z"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgName);
export default __webpack_public_path__ + "static/media/name.39ea7967581bab31c97bc2042d6ad93b.svg";
export { ForwardRef as ReactComponent };